export const visualizationActionTypes = {
  SET_CHART_TYPES: "SET_CHART_TYPES",
  ADD_CHART: "ADD_CHART",
  DELETE_CHART: "DELETE_CHART",
  SET_CHART_DETAILS: "SET_CHART_DETAILS",
  RESET_CHARTS_DATA: "RESET_CHARTS_DATA",
};
